/* ============================================================
   LFDL — Save for later (Mis de côté) — localStorage
   - Stocke les articles mis de côté côté navigateur
   - Affichage en grille compacte (image + titre 2 lignes + prix)
   - Actions : Remettre au panier / Favoris / Supprimer
   ============================================================ */

(function () {
  "use strict";

  var STORAGE_KEY = "lfdlSaveForLater:v1";
	  // Réutilise la wishlist locale du thème (wishlist-local.js)
	  var WISHLIST_KEY = "lfdlWishlist:v1";

	  function readWishlistSet() {
	    var raw = null;
	    try { raw = localStorage.getItem(WISHLIST_KEY); } catch (e) { raw = null; }
	    var data = safeJsonParse(raw, null);
	    var handles = (data && Array.isArray(data.handles)) ? data.handles : [];
	    var set = Object.create(null);
	    for (var i = 0; i < handles.length; i++) {
	      var h = String(handles[i] || "").trim();
	      if (h) set[h] = true;
	    }
	    return set;
	  }

	  function writeWishlistSet(setObj) {
	    try {
	      var handles = Object.keys(setObj || {}).filter(Boolean);
	      localStorage.setItem(WISHLIST_KEY, JSON.stringify({ handles: handles, updatedAt: Date.now() }));
	    } catch (e) {}
	  }

	  function isInWishlist(handle) {
	    if (!handle) return false;
	    var set = readWishlistSet();
	    return !!set[String(handle)];
	  }

	  function toggleWishlist(handle) {
	    if (!handle) return false;
	    var set = readWishlistSet();
	    var k = String(handle);
	    if (set[k]) { delete set[k]; writeWishlistSet(set); return false; }
	    set[k] = true; writeWishlistSet(set); return true;
	  }

  function safeJsonParse(str, fallback) {
    try { return JSON.parse(str); } catch (e) { return fallback; }
  }

  function readStore() {
    var raw = localStorage.getItem(STORAGE_KEY);
    var arr = safeJsonParse(raw, []);
    if (!Array.isArray(arr)) return [];
    return arr.filter(Boolean);
  }

  function writeStore(arr) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr || [])); } catch (e) {}
  }

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function extractHandleFromUrl(url) {
    try {
      var u = new URL(url, window.location.origin);
      var m = u.pathname.match(/\/products\/([^\/]+)/);
      return m ? m[1] : "";
    } catch (e) {
      var m2 = String(url || "").match(/\/products\/([^\/\?\#]+)/);
      return m2 ? m2[1] : "";
    }
  }

  function uniqByVariantId(items) {
    var seen = Object.create(null);
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var k = String(it && it.variantId || "");
      if (!k) continue;
      if (seen[k]) continue;
      seen[k] = true;
      out.push(it);
    }
    return out;
  }

  function addSavedItem(newItem) {
    var items = readStore();
    items.unshift(newItem);
    items = uniqByVariantId(items);
    writeStore(items);
  }

  function removeSavedItem(variantId) {
    var items = readStore().filter(function (it) { return String(it.variantId) !== String(variantId); });
    writeStore(items);
    return items;
  }

  function renderSaved() {
    var root = document.querySelector("[data-lfdl-saved-root]");
    var list = document.querySelector("[data-lfdl-saved-list]");
    if (!root || !list) return;

    var items = readStore();
    if (!items.length) {
      root.hidden = true;
      list.innerHTML = "";
      return;
    }

    root.hidden = false;

    var html = '<div class="lfdl-sfl-grid">';
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var vid = String(it.variantId || "");
      var title = escapeHtml(it.title || "");
      var url = it.url || "#";
      var price = it.price || "";
      var img = it.image || "";
      var handle = it.handle || extractHandleFromUrl(url) || "";

      html += ''
        + '<div class="lfdl-sfl-card" data-vid="' + escapeHtml(vid) + '">'
        +   '<div class="lfdl-sfl-card__media">'
        +     '<a href="' + escapeHtml(url) + '">'
        +       (img ? '<img class="lfdl-sfl-card__img" loading="lazy" src="' + escapeHtml(img) + '" alt="' + title + '">' : '<div class="lfdl-sfl-card__img--ph"></div>')
        +     '</a>'
        +   '</div>'
        +   '<div class="lfdl-sfl-card__meta">'
        +     '<a class="lfdl-sfl-card__title" href="' + escapeHtml(url) + '" title="' + title + '">' + title + '</a>'
        +     (price ? '<div class="lfdl-sfl-card__price">' + escapeHtml(price) + '</div>' : '')
        +   '</div>'
	      +   '<div class="lfdl-sfl-card__actions">'
	      +     '<button type="button" class="lfdl-sfl-card__btn" data-lfdl-sfl-restore="' + escapeHtml(vid) + '">Remettre au panier</button>'
	      +     (handle ? '<button type="button" class="lfdl-sfl-card__btn lfdl-sfl-wishlist-toggle" data-lfdl-wishlist-handle="' + escapeHtml(handle) + '">' + (isInWishlist(handle) ? 'Présent favoris' : 'Ajouter aux favoris') + '</button>' : '')
	      +     '<button type="button" class="lfdl-sfl-card__btn lfdl-sfl-card__btn--danger" data-lfdl-sfl-delete="' + escapeHtml(vid) + '">Supprimer</button>'
	      +   '</div>'
        + '</div>';
    }
    html += "</div>";

    list.innerHTML = html;
  }

  function repositionSavedBlock() {
    var root = document.querySelector("[data-lfdl-saved-root]");
    if (!root) return;
    var target =
      document.querySelector(".lfdl-cart__note") ||
      document.querySelector(".lfdl-cart__summary");
    if (!target || !target.parentNode) return;
    if (root.previousElementSibling === target) return;
    try {
      target.insertAdjacentElement("afterend", root);
    } catch (e) {}
  }

  function postJson(url, payload) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, json: j }; }); });
  }

  function getCartChangeUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root + "cart/change.js";
    return "/cart/change.js";
  }

  function getCartAddUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root + "cart/add.js";
    return "/cart/add.js";
  }

  function onClick(e) {
    var saveBtn = e.target.closest("[data-lfdl-save-for-later]");
    if (saveBtn) {
      e.preventDefault();

      var variantId = saveBtn.getAttribute("data-variant-id");
      var line = parseInt(saveBtn.getAttribute("data-line") || "0", 10);

      if (!variantId) return;

      var item = {
        variantId: String(variantId),
        title: saveBtn.getAttribute("data-title") || "",
        image: saveBtn.getAttribute("data-image") || "",
        url: saveBtn.getAttribute("data-url") || "",
        price: saveBtn.getAttribute("data-price") || "",
        handle: saveBtn.getAttribute("data-handle") || extractHandleFromUrl(saveBtn.getAttribute("data-url") || "")
      };

      addSavedItem(item);

      // Retire du panier, puis reload (on évite les désyncs de total)
      postJson(getCartChangeUrl(), line ? { line: line, quantity: 0 } : { id: Number(variantId), quantity: 0 })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });

      return;
    }

	    var wlBtn = e.target.closest(".lfdl-sfl-wishlist-toggle");
	    if (wlBtn) {
	      e.preventDefault();
	      var h = wlBtn.getAttribute("data-lfdl-wishlist-handle") || "";
	      if (!h) return;
	      var nowIn = toggleWishlist(h);
	      wlBtn.textContent = nowIn ? "Présent favoris" : "Ajouter aux favoris";
	      return;
	    }

    var restoreBtn = e.target.closest("[data-lfdl-sfl-restore]");
    if (restoreBtn) {
      e.preventDefault();
      var vid = restoreBtn.getAttribute("data-lfdl-sfl-restore");
      if (!vid) return;

      restoreBtn.disabled = true;

      postJson(getCartAddUrl(), { items: [{ id: Number(vid), quantity: 1 }] })
        .then(function (res) {
          removeSavedItem(vid);
          window.location.reload();
        })
        .catch(function () {
          restoreBtn.disabled = false;
        });

      return;
    }

    var delBtn = e.target.closest("[data-lfdl-sfl-delete]");
    if (delBtn) {
      e.preventDefault();
      var vid2 = delBtn.getAttribute("data-lfdl-sfl-delete");
      removeSavedItem(vid2);
      renderSaved();
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    repositionSavedBlock();
    renderSaved();
    document.addEventListener("click", onClick, true);
  });
})();
